export class Tag {
    id = ""
    name = ""
    color = "#ff2ecd6f"
    tag_bg = "#ff2ecd6f"

    constructor(values={}) {
        Object.assign(this, values);
    }

    toString() {
        return this.name ? this.name : this.id
    }
}